import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class EmailCampaignBuilderCustomerPreview extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
        <div>
          <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 15, paddingTop: 0, marginTop: 10, marginBottom: 10 }}>{I18n.t('customers')}</h5>

          {this.props.table_data.length > 0
          ?
          <table className="table" style={{ margin: 'auto', border: '1px solid #dddddd', paddingLeft: "15px" }}>
            {this.renderTableHead()}
            {this.renderTableRows()}
          </table>
          :
          <div className="no-records">
            <span className="none">{I18n.t('none')}</span>
          </div>
          }
        </div>
    );
  };

  renderTableHead() {

    var headers = Object.keys(this.props.table_data[0]).map((field) => {
      return <th key={field} style={{ position: "sticky", top: '-17px', borderBottom: '2px solid #dddddd' }} >{field}</th>
    })

    return (
      <thead>
        <tr>
          {headers}
        </tr>
      </thead>
    );
  }

  renderTableRows() {
    var rows = this.props.table_data.map((customer, idx) => {
      var columns = Object.keys(customer).map((field, idx) => {
        return <td key={idx} style={field == I18n.t("email") ? { width: '325px' } : null}>{customer[field]}</td>
      })

      return (
        <tr key={idx} style={idx % 2 === 1 ? { backgroundColor: '#dddddd' } : null}>
          {columns}
        </tr>
      )
    })

    return (
      <tbody>
        {rows}
      </tbody>
    );
  };
};
